function returnPNM() {
    console.log("test PNM inner", PNM);
    return PNM;
}

function closePNM() {
    PNM.close();
}